import React, { useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { AiOutlineBug } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import debugLoggingService from "../../services/debugLoggingService";

export default function ReportBugButton() {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [description, setDescription] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async () => {
    setSending(true);
    const success = await debugLoggingService.sendReport(description);
    setSending(false);
    if (success) {
      setSent(true);
      setTimeout(() => {
        setShow(false);
        setSent(false);
        setDescription("");
      }, 1500);
    }
  };

  return (
    <>
      <Button
        variant="outline-danger"
        onClick={() => setShow(true)}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          zIndex: 9999,
          borderRadius: "50%",
          width: "48px",
          height: "48px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
        }}
        title={t("reportBug.title")}
      >
        <AiOutlineBug size={22} />
      </Button>

      <Modal show={show} onHide={() => { setShow(false); setSent(false); }} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("reportBug.title")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {sent ? (
            <p style={{ color: "green", textAlign: "center", margin: "1rem 0" }}>
              {t("reportBug.sentThankYou")}
            </p>
          ) : (
            <Form>
              <Form.Group>
                <Form.Label>{t("reportBug.describeIssue")}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder={t("reportBug.placeholder")}
                />
              </Form.Group>
              <Form.Text className="text-muted">
                {t("reportBug.diagnosticsNote")}
              </Form.Text>
            </Form>
          )}
        </Modal.Body>
        {!sent && (
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShow(false)}>
              {t("common.cancel")}
            </Button>
            <Button
              variant="danger"
              onClick={handleSubmit}
              disabled={sending || !description.trim()}
            >
              {sending ? t("reportBug.sending") : t("reportBug.submit")}
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
}
